export const CHANGE_VALUE_INPUTS_ENTERPRISE = 'CHANGE_VALUE_INPUTS_ENTERPRISE';
export const GET_INFO_ENTERPRISE            = 'GET_INFO_ENTERPRISE';
export const CHANGE_URL_LOGO                = 'CHANGE_URL_LOGO';
